export default __webpack_public_path__ + "static/media/boy_image.5a432f6a.png";